import SubscriptionsPage from "./SubscriptionsPage";

export default SubscriptionsPage;